// extracted by mini-css-extract-plugin
export default {"Loading":"with-your-orders-styles__Loading__gLEEH"};